import { useCallback, useRef } from 'react';

import { useEditCanvasStore } from '../../../store';
import { type AppNode } from '../../../types';
import { commands } from '../commands';
import { useCommandHistory } from './useCommandHistory';

export function useResizeCommand(nodeId: string) {
  const execute = useCommandHistory((state) => state.execute);
  const snapshotRef = useRef<AppNode | null>(null);

  const onResizeStart = useCallback(() => {
    const node = useEditCanvasStore.getState().nodes.find((obj) => obj.id === nodeId);
    if (node) {
      snapshotRef.current = structuredClone(node);
    }
  }, [nodeId]);

  const onResizeEnd = useCallback(() => {
    const previousNode = snapshotRef.current;
    if (!previousNode) return;

    const currentNode = useEditCanvasStore.getState().nodes.find((obj) => obj.id === nodeId);
    if (!currentNode) return;

    execute(commands.modifyNodes([previousNode], [structuredClone(currentNode)]));
    snapshotRef.current = null;
  }, [execute, nodeId]);

  return { onResizeEnd, onResizeStart };
}
